import { css } from 'styled-components';

export const section = css`
  position: relative;
`;
